import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";
const isAddress = (name) => {
  //Latin-1 without Appendix E
  const re = /^[ "&-.0-:A-Za-z:0-9]{1,36}$/;
  return name && re.test(name)
    ? undefined
    : name === undefined || name?.length === 0
    ? "A valid Suburb must be provided"
    : "A valid Suburb must be provided";
};

const AddressSuburb = ({ ...rest }) => (
  <Field
    name="addresssuburb"
    validate={isAddress}
    label="Address"
    autoComplete=""
    component={TextFieldAdapter}
    subscription={{ touched: true, value: true, error: true }}
    fullWidth
    inputProps={{ maxLength: 36 }}
    {...rest}
  />
);

export default AddressSuburb;
